module.exports = __webpack_public_path__ + "static/media/click.27243d86.wav";